<script lang="ts">
	import type { ItemsSub } from '$lib/tools/graph-db/create_map_state.svelte';
	import type { CartState } from '../../handlers/cart_state.svelte';
	import type { products, sellers } from '$lib/tools/graphdb';

	import LucideIcon from '$lib/utils/components/LucideIcon.svelte';
	import SellerAddProductsList from '../AddCartProductsBar.svelte';
	import Image from '$lib/utils/components/Image.svelte';

	import { envs_calculations_state } from '$lib/utils/states/envs_calculations_state';
	import { utils } from '$lib/utils/utils.svelte';
	import { Loc } from '$lib/tools/locale.svelte';

	let {
		cart_state,
		mode,
		products_sub_fn
	}: {
		cart_state: CartState;
		mode: 'seller' | 'operator';
		products_sub_fn(seller?: sellers): ItemsSub<products>;
	} = $props();

	function add_to_cart_fn(product: products) {
		cart_state.fns.patch_item_one({
			id: product.id,
			image_id: product.image_id,
			name: product.name,
			price: mode === 'seller' ? product.price : (product.retail_price ?? product.price),
			is_box: false,
			Extras: [],
			volume_cm3: envs_calculations_state.calculations.shipments.items.calculate_item_volume_cm3({
				dimensions_cm: product.dimensions_cm,
				standard_size_id: product.Standard_size?.id || null
			})
		});
	}
</script>

<div class="space-y-4">
	{#key cart_state.variables.seller}
		<SellerAddProductsList {products_sub_fn} {cart_state} {add_to_cart_fn} />
	{/key}

	{#if cart_state.variables.items.length > 0}
		<div class="rounded-lg border border-border divide-y divide-border bg-card">
			{#each cart_state.variables.items.toReversed() as item (item.cart_item_id)}
				<div class="flex items-center p-3 gap-4 group">
					<div class="h-12 w-12 rounded-md bg-muted overflow-hidden flex items-center justify-center border shrink-0">
						{#if item.is_box}
							<LucideIcon name="Box" class="text-muted-foreground" size="20" />
						{:else}
							<Image image_id={item.image_id} width="48" height="48" />
						{/if}
					</div>

					<div class="flex-1 min-w-0">
						<div class="font-medium text-sm truncate leading-tight mb-1">
							{item.name}
						</div>
						<div class="text-xs text-muted-foreground font-mono">
							{item.price}
							{Loc('lyd')}
						</div>
					</div>

					<div class="flex flex-col items-end gap-1">
						<div class="flex items-center border rounded-md h-8 bg-background shadow-sm">
							<button
								class="h-full px-2 hover:bg-muted text-muted-foreground transition-colors border-r rtl:border-l rtl:border-r-0"
								onclick={() => cart_state.fns.decrement_item(item.cart_item_id)}
							>
								<LucideIcon name="Minus" size="12" />
							</button>
							<span class="w-8 text-center text-xs font-mono font-bold tabular-nums">{item.quantity}</span>
							<button
								class="h-full px-2 hover:bg-muted text-foreground transition-colors border-l rtl:border-r rtl:border-l-0"
								onclick={() => cart_state.fns.patch_item_one(item)}
							>
								<LucideIcon name="Plus" size="12" />
							</button>
						</div>

						<div class="text-xs font-bold font-mono text-muted-foreground">
							{utils.numbers.number_to_decimals(item.price * item.quantity)}
						</div>
					</div>
				</div>
			{/each}
		</div>
	{/if}
</div>
